module.exports = "<p data-ng-bind-html=\"text\"></p>\r\n";